import React from "react";
import "./index.css";

export const AKAS_LOGO_SRC = `${process.env.PUBLIC_URL || ""}/apple-touch-icon.png`;

const AkasLogo = ({ className = "", decorative = false }) => (
  <img
    src={AKAS_LOGO_SRC}
    alt={decorative ? "" : "Logo AKAS"}
    aria-hidden={decorative ? true : undefined}
    className={`akas-brand-asset ${className}`}
    width={32}
    height={32}
    draggable={false}
  />
);

export default AkasLogo;
